import { ListBaseModel } from '@/api/models';
import z from 'zod';

const OrganizationNestedResultBaseModel = z.object({
  code: z.string(),
  id: z.string(),
  level: z.number(),
  name: z.string(),
  isIntegrated: z.boolean(),
  isExcludedFromOptions: z.boolean(),
});

type OrganizationNestedResultModelType = z.infer<
  typeof OrganizationNestedResultBaseModel
> & {
  descendant: OrganizationNestedResultModelType[];
};

const OrganizationSnapshotRecursiveModel: z.ZodType<OrganizationNestedResultModelType> =
  OrganizationNestedResultBaseModel.extend({
    descendant: z.lazy(() => OrganizationSnapshotRecursiveModel.array()),
  });

export const OrganizationsSnapshotModel = ListBaseModel.extend({
  results: OrganizationSnapshotRecursiveModel.array(),
});
